import Papa from 'papaparse';

export function unparse(content) {
  if (content) {
    let processedContent = content.map((row) => {
      return row.map((cell) => {
        if (typeof cell === "string") {
          return cell.replace(new RegExp('\r?\n', 'g'), 'NEWLINEHERE');
        }
        else {
          return cell;
        }
      });
    })

    return Papa.unparse(processedContent);
  }

  return '';
}

export function parse(content) {
  if (content) {
    let parsedContent = Papa.parse(content);

    if (parsedContent.errors.length) {
      return [];
    }

    let processedContent = parsedContent.data.map((row) => {
      return row.map((cell) => {
        if (typeof cell === "string") {
          return cell.replace(new RegExp('NEWLINEHERE','g'), '\n');
        }
        else {
          return cell;
        }
      });
    })

    return processedContent;
  }

  return [];
}